window.searchIntegration = {
  addToCart: function(variantId, quantity = 1) {
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity
      }],
      'sections': 'cart-drawer,cart-icon-bubble'
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (!data.sections) return;

      try {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && data.sections['cart-icon-bubble']) {
          cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
        }
      } catch (e) { console.error('Cart Icon Update Failed:', e); }

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections['cart-drawer']) {
          const parsedHTML = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          const newDrawerContent = parsedHTML.querySelector('cart-drawer');

          if (newDrawerContent) {
            cartDrawer.innerHTML = newDrawerContent.innerHTML;
            cartDrawer.classList.remove('is-empty');

            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        }
      } catch (e) { console.error('Cart Drawer Update Failed:', e); }
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    });
  },

chooseOptions: function(productId) {
  const modalSelector = `#QuickAdd-${productId}`;
  const opener = document.querySelector(`modal-opener[data-modal="${modalSelector}"]`);
  if (opener) {
    const button = opener.querySelector('button');
    if (button) {
      button.click();
    } else {
      opener.click();
    }
  } else {
    console.error('Modal opener not found for product ID:', productId);
  }
}

};